import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Table } from 'antd';
import moment from 'moment-timezone';

@inject('store')
@observer
export class PNLView extends Component {
    render() {
        const timezone = this.props.store.userStore.currentUser.timezone;
        return (
            <Table
                rowKey={'_id'}
                scroll={{ x: 1000 }}
                columns={[
                    {
                        title: 'Side',
                        dataIndex: 'side',
                        key: 'side',
                        render(text) {
                            return text === 'BUY' ? (
                                <i className={`fal fa-arrow-up success`} />
                            ) : text === 'SELL' ? (
                                <i className={`fal fa-arrow-down error`} />
                            ) : null;
                        }
                    },
                    {
                        title: 'Id',
                        dataIndex: '_id',
                        key: '_id'
                    },
                    {
                        title: 'Symbol',
                        dataIndex: 'symbol',
                        key: 'symbol'
                    },
                    {
                        title: 'Qty',
                        dataIndex: 'entry_orders_filled',
                        key: 'entry_orders_filled'
                    },
                    {
                        title: 'Entry Price',
                        dataIndex: 'avg_entry',
                        key: 'avg_entry',
                        render(text, o) {
                            const b = o.avg_entry;
                            return b.toFixed(4);
                        }
                    },
                    {
                        title: 'Exit Price',
                        dataIndex: 'avg_exit',
                        key: 'avg_exit',
                        render(text, o) {
                            const b = o.avg_exit;
                            return b.toFixed(4);
                        }
                    },
                    {
                        title: 'P&L(Excl fee)',
                        dataIndex: 'pnl',
                        key: 'pnl',
                        render(text, o) {
                            return (
                                <span className={text < 0 ? 'error' : 'success'}>
                                    {text.toFixed(8)} (${o.pnl_usd.toFixed(2)})
                                </span>
                            );
                        }
                    },
                    {
                        title: 'Fee',
                        dataIndex: 'fees',
                        key: 'fees',
                        render(text, o) {
                            return (
                                <span className={text < 0 ? 'success' : 'error'}>
                                    {(text * -1).toFixed(8)} (${(o.fees_usd * -1).toFixed(2)})
                                </span>
                            );
                        }
                    },
                    {
                        title: 'Total',
                        dataIndex: 'total',
                        key: 'total',
                        render(text, o) {
                            const profit = o.pnl - o.fees;
                            const profitUSD = o.pnl_usd - o.fees_usd;
                            return (
                                <span className={profit > 0 ? 'success' : 'error'}>
                                    {profit.toFixed(8)} (${profitUSD.toFixed(2)})
                                </span>
                            );
                        }
                    },
                    {
                        title: 'Closed At',
                        dataIndex: 'updated_at',
                        key: 'updated_at',
                        render(text) {
                            return moment(text)
                                .tz(timezone)
                                .format('DD/MM/YYYY hh:mm a');
                        }
                    }
                ]}
                dataSource={this.props.store.makoBotStore.positions}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/MakoBot/TradeView/PNLView/index.js